import { Alert, Box, Snackbar, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import HorizontalLinearStepper from "../components/common/HorizontalLinearStepper/HorizontalLinearStepper.tsx";
import LoadingPlaceholder from "../components/common/LoadingPlaceholder/LoadingPlaceholder.tsx";
import { useAppStore } from "../hooks/useStores.tsx";
import BriaDesignEditor from "./BriaDesignEditor.tsx";
import { PopUpSteps } from "./constants/mock-data.ts";
import styles from "./styles/DesignEditorPopup.module.scss";

const BriaDesignEditorPopup = () => {
	const { designEditorStore } = useAppStore();
	const { t } = useTranslation("translation", { keyPrefix: "editor.popup" });
	const [successMessage, setSuccessMessage] = useState<string | null>(null);
	const CAMPAIGN_INDEX = PopUpSteps.indexOf("campaigns");

	const setActiveStep = (newStep: number) => {
		designEditorStore.setProperty("newStep", newStep);
	};

	const renderPopupActionsHeader = () => (
		<Box className={styles.popupActionsHeader}>
			<Box className={styles.row1}>
				<Typography className={styles.title}>{t("title")}</Typography>
			</Box>
			<Box className={styles.separator} />
			<Box className={styles.row2}>
				<HorizontalLinearStepper
					steps={designEditorStore.editorStepperSteps.map((step) => step.title)}
					activeStep={designEditorStore.activeStep}
					readonly
					setActiveStep={setActiveStep}
					disabledStep={designEditorStore.editorStepperDisabledSteps}
					disableAll={designEditorStore.activeStep === CAMPAIGN_INDEX}
					disableClick={true}
				/>
				<Box className={styles.buttons}>
					{designEditorStore.isLoadingTemplate ? (
						<Box className={styles.loadingContainer}>
							<Typography>{t("buttons.templateLoading")}</Typography>
							<LoadingPlaceholder className={styles.loadingPlaceholder} isLoading={true} size={15} />
						</Box>
					) : (
						<>
							{!designEditorStore.hideCampaignResultContent ? (
								// TODO : connection between ads editor and ads generator
								// <BriaButton
								// 	onClick={async () => {
								// 		campaignStore.setProperty("isSavingToMyCampaign", true);
								// 		const newTemplateId = await saveNewCampaign({
								// 			templateName: designEditorStore.campaignName,
								// 		});
								// 		newTemplateId && designEditorStore.setProperty("designEditorPopup", false);
								// 	}}
								// 	className={styles.saveToMyCampaignButton}
								// 	buttonType="primary"
								// 	disabled={designEditorStore.campaignUpdatedTemplate === undefined || isLoading}
								// 	loading={isLoading}
								// >
								// 	{t("buttons.saveToMyCampaign")}
								// </BriaButton>
								<></>
							) : null}
						</>
					)}
				</Box>
			</Box>
			<Box className={styles.separator} />
		</Box>
	);

	return (
		<Box className={styles.container}>
			{renderPopupActionsHeader()}
			<BriaDesignEditor isPopupView={true} />
			<Snackbar
				autoHideDuration={2000}
				open={!!successMessage}
				onClose={() => setSuccessMessage(null)}
				className={styles.saveSuccessToast}
			>
				<Alert severity="success">{successMessage}</Alert>
			</Snackbar>
		</Box>
	);
};

const ObservedComponent = observer(BriaDesignEditorPopup);
export default ObservedComponent;
